import {
  DocumentCategoriesListListData,
  documentCategoriesListListInfiniteOptions,
  Dropdown,
  PaginatedDropdownList,
  UsersListListData,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { UserRoleCRM } from '@crm/types'
import {
  defaultFiltersMultipleValues,
  defaultFiltersNumberValues
} from '@crm/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useTranslation } from 'react-i18next'

export const DocumentsFilter = () => {
  const { params, updateQuery } = useQueryUpdate()
  const { t } = useTranslation()

  const hasPermissionMix = useRolePermission([
    UserRoleCRM.manager,
    UserRoleCRM.admin
  ])

  const userValue = defaultFiltersMultipleValues(params?.owner)
  const categoryValue = defaultFiltersNumberValues(params?.category)

  return (
    <>
      {hasPermissionMix && (
        <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
          value={userValue}
          className="select-min-width"
          popupMatchSelectWidth
          placeholder={t('filter.lead_owner')}
          getQueryFunction={usersListListInfiniteOptions}
          onChange={(owner) => updateQuery({ owner })}
          mode="multiple"
          maxTagCount={1}
          maxTagTextLength={6}
          baseOptions={{
            query: {
              preference: params?.owner
            }
          }}
        />
      )}

      <InfiniteSelect<
        DocumentCategoriesListListData,
        PaginatedDropdownList,
        Dropdown
      >
        value={categoryValue}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('filter.category')}
        getQueryFunction={documentCategoriesListListInfiniteOptions}
        onChange={(category) => updateQuery({ category })}
        baseOptions={{
          query: {
            preference: params?.category
          }
        }}
      />
    </>
  )
}
